// extracted by mini-css-extract-plugin
module.exports = {"ant-layout-sider-trigger":"style_ant-layout-sider-trigger__2xlu8","dropdown":"style_dropdown__3tRkP","avatar":"style_avatar__19Ab4","menuIcon":"style_menuIcon__1HWaR"};